import React, { useContext, useEffect, useState } from 'react';
import { Container, Col, Button, Form, Modal, Spinner, Alert } from 'react-bootstrap';

import $ from 'jquery';
import { AppContext } from '../App';

export const EnquiryTypes = () => {
    const { setPage, postCall, getLoad, load, enquiryTypes, setEnquiryTypes } = useContext(AppContext);
    const [updateModal, setUpdateModal] = useState(false);
    const [updateLoad, setUpdateLoad] = useState(false);
    const [editable, setEditable] = useState(false);
    useEffect(() => {
        if (!updateModal) {
            setEditable(false);
        }
    }, [updateModal]);
    const addPurticular = (e) => {
        e.preventDefault();
        let name = e.target.name.value;
        if (name === "") {
            document.querySelector('#name_err').classList.add('bdr-red');
            setTimeout(() => { document.querySelector('#name_err').classList.remove('bdr-red'); }, 5000);
        } else { document.querySelector('#name_err').classList.remove('bdr-red') }
        if (name !== "") {
            if (editable) {
                setUpdateLoad(true)
                postCall('api/e/update/enquiry/type/', { e_id: activeItem.substring(1), name: name }).then(res => {
                    setUpdateLoad(false);
                    setUpdateModal(false);
                    setEnquiryTypes(prev => ({ ...prev, [res.data.id]: res.data.data }));
                    setActiveItem();
                }).catch(err => {
                    setUpdateLoad(false);
                });
            } else {
                setUpdateLoad(true)
                postCall('api/e/add/enquiry/type/', { name: name }).then(res => {
                    setUpdateLoad(false);
                    setUpdateModal(false);
                    setEnquiryTypes(prev => ({ ...prev, [res.data.id]: res.data.data }));
                    setContent(prev => [...prev, res.data.id]);
                }).catch(err => {
                    setUpdateLoad(false);
                });
            }
        }
    }
    // Default search...
    const [content, setContent] = useState();
    useEffect(() => {
        if (enquiryTypes !== undefined && content === undefined) {
            setContent(Object.keys(enquiryTypes));
        }
    }, [enquiryTypes]);
    const search = (key) => {
        if (key !== "" && key !== undefined) {
            if (enquiryTypes !== undefined) {
                if (Object.keys(enquiryTypes).length > 0) {
                    setContent(prev => ([]));
                    Object.keys(enquiryTypes).map(item => {
                        if (enquiryTypes[item].name.toLowerCase().includes(key.toLowerCase())) {
                            setContent(prev => ([...prev, item]));
                        }
                    });
                }
            }
        } else {
            setContent(Object.keys(enquiryTypes));
        }
    }
    // Pagination
    const [numPage, setNumPage] = useState();
    const [activePage, setActivePage] = useState();
    const [start, setStart] = useState(0);
    const [indexStart, setIndexStart] = useState(0);
    // number of items per page
    const itemCount = 10;
    // number of pages in pagination
    const pageCount = 10;
    useEffect(() => {
        if (content !== undefined) {
            let total_length = Object.keys(content).length;
            setNumPage(Math.ceil(total_length / itemCount));
            setActivePage(0);
        }
    }, [content]);
    useEffect(() => {
        setStart(0);
        setIndexStart(0);
    }, [numPage]);
    // #Pagination	
    const [changeStatLoad, setChangeStatLoad] = useState(false);
    const [activeItem, setActiveItem] = useState();
    const changeStatus = (id, status) => {
        if (id !== "" && status !== "") {
            setChangeStatLoad(true);
            setActiveItem(id);
            postCall('api/e/change/enquiry/type/status/', { e_id: id.substring(1), status: status }).then(res => {
                setEnquiryTypes(prev => ({ ...prev, [res.data.id]: res.data.data }));
                setChangeStatLoad(false);
                setActiveItem();
            }).catch(err => {
                setChangeStatLoad(false);
                setActiveItem();
            });
        }
    }
    return (
        <div className='container-fluid'>
            <div className="bgp flex-wrap p-2 br-3 mb-2 align-items-center justify-content-between" >
                <div className="px-2" >
                    <span>{getLoad ? (<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>) : 'Enquiry Types'}</span>
                </div>
                <Button onClick={() => { setUpdateModal(true) }} className="btn-t1"  ><i className="bi bi-plus-circle"></i> Add new</Button>

            </div>
            <div className="dash-body-content">
                {
                    content !== undefined && enquiryTypes !== undefined ? (
                        content.length > 0 ? (
                            content.map((item, ii) => (
                                activePage !== undefined && ii >= activePage * itemCount && ii < activePage * itemCount + itemCount ? (
                                    <div className="closed-item p-2 br-3 flex-wrap align-items-center justify-content-between mb-2 bgs1 bdr2" key={`vend_${ii}`} >
                                        <div className="d-grid" >
                                            <span className="f18 tc-blue f200 d-flex al-end gap-1" >
                                                {
                                                    enquiryTypes[item].status ? (
                                                        <span className="sucess-tag f16 px-1 br3" ><i className="bi bi-check-circle-fill"></i></span>
                                                    ) : (
                                                        <span className="error-tag f16 px-1 br3" ><i className="bi bi-x-circle-fill"></i></span>
                                                    )
                                                }
                                                {enquiryTypes[item].name}</span>
                                        </div>
                                        <div className="d-flex just-end al-center gap-1">
                                            {
                                                !enquiryTypes[item].global ? (
                                                    <Button onClick={() => {
                                                        setUpdateModal(true);
                                                        setEditable(true);
                                                        setActiveItem(item);
                                                    }} className="btn-t1-r br3" size="sm" ><i className="bi bi-pencil-square"></i> Edit</Button>
                                                ) : null
                                            }

                                            {
                                                activeItem !== undefined && activeItem === item && changeStatLoad ? (
                                                    <Button className="btn-t1-r br3" size="sm"><span className="please-wait-spinner d-flex al-center gap-1" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
                                                ) : (
                                                    enquiryTypes[item].status ? (
                                                        <Button onClick={() => { changeStatus(item, false) }} className="btn-disable br3 d-flex gap-1" size="sm" ><i className="bi bi-x-circle-fill d-flex al-center"></i> Disable</Button>
                                                    ) : (
                                                        <Button onClick={() => { changeStatus(item, true) }} className="btn-enable br3 d-flex gap-1" size="sm" ><i className="bi bi-check-circle-fill d-flex al-center"></i> Activate</Button>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                ) : ''
                            ))
                        ) : (<Alert variant="info m-3" >NOT found!</Alert>)
                    ) : (<Alert variant="warning m-3" className="t-red br-3" >Something went wrong!</Alert>)
                }
            </div>
            <Modal size="xl" show={updateModal} backdrop="static" onHide={() => { setUpdateModal(false) }}>
                <Modal.Header closeButton><span className="tc-blue f18 f200" >{editable ? 'Edit Enquiry Type' : 'Add Enquiry Type'}</span></Modal.Header>
                <Modal.Body>
                    <Form onSubmit={addPurticular} >
                        <Form.Group className="mb-3">
                            <Form.Label className="tc2" >Enquiry Type name</Form.Label>
                            <Form.Control type="text" id="name_err" defaultValue={editable !== undefined && activeItem !== undefined && editable ? enquiryTypes[activeItem].name : ''} name="name" className="shadow-none br3" />
                        </Form.Group>
                        <div className="d-grid">
                            {
                                updateLoad ? (
                                    <Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
                                ) : (
                                    <Button type="submit" className="btn-t1 br3">SAVE</Button>
                                )
                            }
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        </div>
    )
}